module.exports = __webpack_public_path__ + "static/2front-strategy-3-95d2608bbcbaeec166ff6bfa0b21ff5f.png";